import {
  Avatar,
  Badge,
  ClickAwayListener,
  Grow,
  makeStyles,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Tooltip,
  Typography,
  useTheme,
  withStyles,
} from "@material-ui/core";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import {
  default as React,
  useContext,
  useEffect,
  useMemo,
  useReducer,
  useRef,
  useState,
} from "react";
import { Link as RouterLink, useHistory, useLocation } from "react-router-dom";
import { getBackendUrl } from "../config";
import useHelps from "../hooks/useHelps";

import { useActiveMenu } from "../context/ActiveMenuContext";
import { AuthContext } from "../context/Auth/AuthContext";
import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";

import { Can } from "../components/Can";

import { useMediaQuery } from "@material-ui/core";
import {
  ArrowSquare,
  ArrowSwapHorizontal,
  Buliding,
  Calendar,
  CalendarEdit,
  CodeCircle,
  Flash,
  Grid1,
  Hierarchy,
  HomeTrendUp,
  Information,
  Kanban,
  KeyboardOpen,
  Logout,
  MessageFavorite,
  MoneySend,
  Notepad2,
  Notification1,
  Paperclip,
  People,
  Profile2User,
  Setting,
  Setting2,
  Tag,
  UserAdd,
  VolumeHigh,
  VolumeUp,
  Whatsapp,
} from "iconsax-react";
import { isArray } from "lodash";
import toastError from "../errors/toastError";
import usePlans from "../hooks/usePlans";
import ColorModeContext from "../layout/themeContext";
import api from "../services/api";
import { socketConnection } from "../services/socket";
import { i18n } from "../translate/i18n";
import logoIcon from "../assets/SoLogo.png";
import logoFull from "../assets/logo.png";
import { buildMenuConfig } from "./menuConfig";
import SidebarNavFromConfig from "./SidebarNavFromConfig";

const ICON_RAIL_WIDTH = 68;

const useStyles = makeStyles((theme) => ({
  iconRail: {
    width: ICON_RAIL_WIDTH,
    minWidth: ICON_RAIL_WIDTH,
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: theme.palette.sidebar?.background || "#1B2431",
    paddingTop: 12,
    paddingBottom: 12,
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: theme.zIndex.drawer + 2,
    overflowY: "auto",
    overflowX: "hidden",
    transition: "width 0.3s ease, min-width 0.3s ease",
    "&::-webkit-scrollbar": {
      width: 0,
    },
  },
  iconRailExpanded: {
    "&&": {
      alignItems: "stretch",
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  navSectionExpanded: {
    "&&": {
      alignItems: "stretch",
      padding: "0",
    },
  },
  iconButtonExpanded: {
    "&&": {
      width: "100%",
      height: "auto",
      minHeight: 44,
      justifyContent: "flex-start",
      paddingLeft: 23,
      paddingRight: 12,
      flexDirection: "row",
      alignItems: "center",
      gap: 0,
    },
    "& > *:first-of-type": {
      width: 22,
      minWidth: 22,
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "& svg": {
      width: 22,
      height: 22,
      flexShrink: 0,
    },
  },
  iconButtonIconWrap: {
    width: 22,
    minWidth: 22,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  iconButtonLabel: {
    fontSize: 13,
    fontWeight: 500,
    color: theme.palette.sidebar?.icon || "#94A3B8",
    fontFamily: '"Inter", sans-serif',
    flex: 1,
    minWidth: 0,
    lineHeight: 1.4,
    marginLeft: 10,
    textAlign: "left",
    alignSelf: "center",
    whiteSpace: "normal",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
  iconButtonSubmenuIndicator: {
    flexShrink: 0,
    marginLeft: "auto",
    opacity: 0.7,
    color: theme.palette.sidebar?.icon || "#94A3B8",
    fontSize: 18,
  },
  iconButtonLabelActive: {
    color: theme.palette.sidebar?.textActive || "#FFFFFF",
    fontWeight: 600,
  },
  logoContainer: {
    width: 42,
    height: 42,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 8,
    cursor: "pointer",
    borderRadius: 12,
    overflow: "hidden",
    position: "relative",
    transition: "width 0.3s ease",
  },
  logoContainerExpanded: {
    "&&": {
      width: "100%",
      height: 52,
      justifyContent: "center",
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  logoImg: {
    width: 36,
    height: 36,
    objectFit: "contain",
    transition: "opacity 0.3s ease",
  },
  logoImgCollapsed: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
  logoImgExpanded: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    height: 50,
    width: "auto",
    maxWidth: "88%",
  },
  navSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 2,
    width: "100%",
    padding: "0 8px",
    flex: 1,
  },
  navItemCollapsed: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  divider: {
    width: 32,
    height: 1,
    backgroundColor: theme.palette.sidebar?.divider || "rgba(255,255,255,0.08)",
    margin: "8px 0",
    borderRadius: 1,
  },
  dividerExpanded: {
    width: "100%",
    height: 1,
    backgroundColor: theme.palette.sidebar?.divider || "rgba(255,255,255,0.08)",
    margin: "8px 0",
    borderRadius: 1,
  },
  iconButton: {
    width: 44,
    minWidth: 44,
    height: 44,
    flexShrink: 0,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
    color: theme.palette.sidebar?.icon || "#94A3B8",
    backgroundColor: "transparent",
    position: "relative",
    border: "none",
    outline: "none",
    "&:hover": {
      backgroundColor: theme.palette.sidebar?.hoverBackground || "rgba(255,255,255,0.08)",
      color: "#FFFFFF",
    },
    "& svg": {
      width: 22,
      height: 22,
      flexShrink: 0,
    },
  },
  iconButtonActive: {
    color: theme.palette.sidebar?.iconActive || "#FFFFFF",
    "&:hover": {
      backgroundColor: theme.palette.sidebar?.hoverBackground || "rgba(255,255,255,0.08)",
      color: theme.palette.sidebar?.iconActive || "#FFFFFF",
    },
  },
  badgeDot: {
    "& .MuiBadge-badge": {
      backgroundColor: "#ef5350",
      color: "#fff",
      minWidth: 8,
      height: 8,
      padding: 0,
      top: 6,
      right: 6,
      boxShadow: `0 0 0 2px ${theme.palette.sidebar?.background || "#1B2431"}`,
    },
  },
  badgeContent: {
    "& .MuiBadge-badge": {
      backgroundColor: "#ef5350",
      color: "#fff",
      fontSize: 10,
      minWidth: 18,
      height: 18,
      top: 2,
      right: 2,
      boxShadow: `0 0 0 2px ${theme.palette.sidebar?.background || "#1B2431"}`,
    },
  },
  bottomSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
    padding: "8px 0",
    marginTop: "auto",
  },
  bottomSectionExpanded: {
    "&&": {
      alignItems: "stretch",
      padding: "8px 0",
    },
  },
  userAvatar: {
    width: 38,
    height: 38,
    cursor: "pointer",
    border: "2px solid rgba(255,255,255,0.15)",
    transition: "all 0.2s ease",
    "&:hover": {
      border: "2px solid #0B3C84",
      transform: "scale(1.05)",
    },
  },
  // Popover styles
  popoverPaper: {
    backgroundColor: theme.palette.type === "dark" ? "#1E293B" : "#FFFFFF",
    borderRadius: 14,
    boxShadow: "0 10px 40px rgba(0,0,0,0.15), 0 2px 10px rgba(0,0,0,0.08)",
    minWidth: 210,
    maxWidth: 260,
    padding: "8px 0",
    border: theme.palette.type === "dark" ? "1px solid rgba(255,255,255,0.06)" : "1px solid rgba(0,0,0,0.06)",
    overflow: "hidden",
  },
  popoverHeader: {
    padding: "12px 16px 8px",
    borderBottom: theme.palette.type === "dark" ? "1px solid rgba(255,255,255,0.06)" : "1px solid rgba(0,0,0,0.06)",
    marginBottom: 4,
  },
  popoverTitle: {
    fontSize: 11,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.8px",
    color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
    fontFamily: '"Inter", sans-serif',
  },
  popoverItem: {
    padding: "10px 16px",
    display: "flex",
    alignItems: "center",
    gap: 12,
    borderRadius: 0,
    transition: "all 0.15s ease",
    fontFamily: '"Inter", sans-serif',
    "&:hover": {
      backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.05)" : "#F1F5F9",
    },
  },
  popoverItemActive: {
    backgroundColor: "#0B3C84",
    borderLeft: "3px solid rgba(255,255,255,0.35)",
    "&:hover": {
      backgroundColor: "#082D63",
    },
  },
  popoverItemIcon: {
    width: 32,
    height: 32,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#F1F5F9",
    color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
    flexShrink: 0,
    "& svg": {
      width: 18,
      height: 18,
    },
  },
  popoverItemIconActive: {
    backgroundColor: "rgba(255,255,255,0.15)",
    color: "#FFFFFF",
  },
  popoverItemText: {
    fontSize: 13,
    fontWeight: 500,
    color: theme.palette.type === "dark" ? "#E2E8F0" : "#334155",
    fontFamily: '"Inter", sans-serif',
    lineHeight: 1.3,
  },
  popoverItemTextActive: {
    color: "#FFFFFF",
    fontWeight: 600,
  },
  // User menu popover
  userMenuPaper: {
    backgroundColor: theme.palette.type === "dark" ? "#1E293B" : "#FFFFFF",
    borderRadius: 14,
    boxShadow: "0 10px 40px rgba(0,0,0,0.15), 0 2px 10px rgba(0,0,0,0.08)",
    minWidth: 180,
    padding: "8px 0",
    border: theme.palette.type === "dark" ? "1px solid rgba(255,255,255,0.06)" : "1px solid rgba(0,0,0,0.06)",
  },
  userMenuHeader: {
    padding: "12px 16px",
    borderBottom: theme.palette.type === "dark" ? "1px solid rgba(255,255,255,0.06)" : "1px solid rgba(0,0,0,0.06)",
    marginBottom: 4,
  },
  userName: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.type === "dark" ? "#E2E8F0" : "#1E293B",
    fontFamily: '"Inter", sans-serif',
  },
  userEmail: {
    fontSize: 12,
    color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
    fontFamily: '"Inter", sans-serif',
    marginTop: 2,
  },
  logoutItem: {
    color: "#ef5350",
    "&:hover": {
      backgroundColor: "rgba(239,83,80,0.08)",
    },
  },
}));

const reducer = (state, action) => {
  if (action.type === "LOAD_CHATS") {
    const chats = action.payload;
    const newChats = [];
    if (isArray(chats)) {
      chats.forEach((chat) => {
        const chatIndex = state.findIndex((u) => u.id === chat.id);
        if (chatIndex !== -1) {
          state[chatIndex] = chat;
        } else {
          newChats.push(chat);
        }
      });
    }
    return [...state, ...newChats];
  }
  if (action.type === "UPDATE_CHATS") {
    const chat = action.payload;
    const chatIndex = state.findIndex((u) => u.id === chat.id);
    if (chatIndex !== -1) {
      state[chatIndex] = chat;
      return [...state];
    } else {
      return [chat, ...state];
    }
  }
  if (action.type === "DELETE_CHAT") {
    const chatId = action.payload;
    const chatIndex = state.findIndex((u) => u.id === chatId);
    if (chatIndex !== -1) {
      state.splice(chatIndex, 1);
    }
    return [...state];
  }
  if (action.type === "RESET") {
    return [];
  }
  if (action.type === "CHANGE_CHAT") {
    const changedChats = state.map((chat) => {
      if (chat.id === action.payload.chat.id) {
        return action.payload.chat;
      }
      return chat;
    });
    return changedChats;
  }
};

// ==========================================
// Sub-component: Icon Button with Tooltip
// ==========================================
const NavIconButton = ({ icon, label, to, isActive, onClick, showBadge, badgeContent, classes, expanded }) => {
  const history = useHistory();

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    } else if (to) {
      history.push(to);
    }
  };

  const button = (
    <div
      className={`${classes.iconButton} ${isActive ? classes.iconButtonActive : ""} ${expanded ? classes.iconButtonExpanded || "" : ""}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
    >
      {icon}
      {expanded && classes.iconButtonLabel && (
        <span className={`${classes.iconButtonLabel} ${isActive && classes.iconButtonLabelActive ? classes.iconButtonLabelActive : ""}`}>
          {label}
        </span>
      )}
    </div>
  );

  const wrappedButton = showBadge ? (
    <Badge
      badgeContent={badgeContent || "!"}
      overlap="rectangular"
      className={badgeContent ? classes.badgeContent : classes.badgeDot}
      variant={badgeContent ? "standard" : "dot"}
    >
      {button}
    </Badge>
  ) : (
    button
  );

  if (expanded) return wrappedButton;
  return (
    <Tooltip title={label} placement="right" arrow>
      {wrappedButton}
    </Tooltip>
  );
};

// ==========================================
// Sub-component: Popover Menu for submenus
// ==========================================
const PopoverMenu = ({ anchorEl, open, onClose, title, items, classes }) => {
  const location = useLocation();
  const history = useHistory();

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="right-start"
      transition
      style={{ zIndex: 1500 }}
      modifiers={{
        offset: { enabled: true, offset: "0, 8" },
        preventOverflow: { enabled: true, boundariesElement: "viewport" },
      }}
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps} style={{ transformOrigin: "left top" }}>
          <Paper className={classes.popoverPaper}>
            <ClickAwayListener onClickAway={onClose}>
              <div>
                {title && (
                  <div className={classes.popoverHeader}>
                    <Typography className={classes.popoverTitle}>{title}</Typography>
                  </div>
                )}
                <MenuList autoFocusItem={false}>
                  {items.map((item) => {
                    if (!item) return null;
                    const itemActive = location.pathname === item.to;
                    return (
                      <MenuItem
                        key={item.to}
                        className={`${classes.popoverItem} ${itemActive ? classes.popoverItemActive : ""}`}
                        onClick={() => {
                          history.push(item.to);
                          onClose();
                        }}
                      >
                        <div className={`${classes.popoverItemIcon} ${itemActive ? classes.popoverItemIconActive : ""}`}>
                          {item.icon}
                        </div>
                        <Typography className={`${classes.popoverItemText} ${itemActive ? classes.popoverItemTextActive : ""}`}>
                          {item.label}
                        </Typography>
                      </MenuItem>
                    );
                  })}
                </MenuList>
              </div>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};

// ==========================================
// Main Component
// ==========================================
const MainListItems = ({ sidebarExpanded = false, sidebarWidth = ICON_RAIL_WIDTH, ...props }) => {
  const { whatsApps } = useContext(WhatsAppsContext);
  const { user } = useContext(AuthContext);

  const [connectionWarning, setConnectionWarning] = useState(false);
  const [showCampaigns, setShowCampaigns] = useState(false);
  const [showKanban, setShowKanban] = useState(false);
  const backendUrl = getBackendUrl();
  const [showSchedules, setShowSchedules] = useState(false);
  const { handleLogout } = useContext(AuthContext);
  const [showInternalChat, setShowInternalChat] = useState(false);
  const history = useHistory();
  const classes = useStyles();
  const [invisible, setInvisible] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchParam] = useState("");
  const [chats, dispatch] = useReducer(reducer, []);
  const [profileUrl, setProfileUrl] = useState(null);
  const { getPlanCompany } = usePlans();

  const { colorMode } = useContext(ColorModeContext);
  const [isAdmin, setIsAdmin] = useState(false);
  const toggleColorMode = () => {
    colorMode.toggleColorMode();
  };

  const { socket } = useContext(AuthContext);
  const { setActiveMenu } = useActiveMenu();
  const location = useLocation();
  const theme = useTheme();

  const [showOpenAi, setShowOpenAi] = useState(false);
  const [showIntegrations, setShowIntegrations] = useState(false);
  const greaterThenSm = useMediaQuery(theme.breakpoints.up("md"));
  const [showExternalApi, setShowExternalApi] = useState(false);

  const { list } = useHelps();
  const [hasHelps, setHasHelps] = useState(false);

  // Popover state
  const [openPopover, setOpenPopover] = useState(null); // 'management' | 'kanban' | 'campaigns' | 'user' | null
  const popoverAnchors = useRef({});

  useEffect(() => {
    setIsAdmin(user.profile === "admin");
  }, [user]);

  useEffect(() => {
    async function checkHelps() {
      const helps = await list();
      setHasHelps(helps.length > 0);
    }
    checkHelps();
  }, []);

  useEffect(() => {
    const companyId = user.companyId;
    const userId = user.id;
    const socket = socketConnection({ companyId, userId: user.id });
    if (!socket) {
      return () => {};
    }
    const ImageUrl = user.profileImage;
    if (ImageUrl !== undefined && ImageUrl !== null)
      setProfileUrl(
        `${backendUrl}/public/company${companyId}/user/${ImageUrl}`
      );
    else setProfileUrl(`${process.env.FRONTEND_URL}/nopicture.png`);

    socket.on(`company-${companyId}-auth`, (data) => {
      if (data.user.id === +userId) {
        toastError("Sua conta foi acessada em outro computador.");
        setTimeout(() => {
          localStorage.clear();
          window.location.reload();
        }, 1000);
      }
    });

    socket.emit("userStatus");
    const interval = setInterval(() => {
      socket.emit("userStatus");
    }, 1000 * 60 * 5);

    return () => {
      socket.disconnect();
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);
      setShowCampaigns(planConfigs.plan.useCampaigns);
      setShowKanban(planConfigs.plan.useKanban);
      setShowOpenAi(planConfigs.plan.useOpenAi);
      setShowIntegrations(planConfigs.plan.useIntegrations);
      setShowSchedules(planConfigs.plan.useSchedules);
      setShowInternalChat(planConfigs.plan.useInternalChat);
      setShowExternalApi(planConfigs.plan.useExternalApi);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchChats();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam, pageNumber]);

  useEffect(() => {
    const companyId = user.companyId;
    const socket = socketConnection({ companyId, userId: user.id });
    if (!socket) {
      return () => {};
    }
    socket.on(`company-${companyId}-chat`, (data) => {
      if (data.action === "new-message") {
        dispatch({ type: "CHANGE_CHAT", payload: data });
      }
      if (data.action === "update") {
        dispatch({ type: "CHANGE_CHAT", payload: data });
      }
    });
    return () => {
      socket.disconnect();
    };
  }, [user]);

  useEffect(() => {
    let unreadsCount = 0;
    if (chats.length > 0) {
      for (let chat of chats) {
        for (let chatUser of chat.users) {
          if (chatUser.userId === user.id) {
            unreadsCount += chatUser.unreads;
          }
        }
      }
    }
    if (unreadsCount > 0) {
      setInvisible(false);
    } else {
      setInvisible(true);
    }
  }, [chats, user.id]);

  const handleClickLogout = () => {
    if (theme.mode === "dark") toggleColorMode();
    handleLogout();
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (whatsApps.length > 0) {
        const offlineWhats = whatsApps.filter((whats) => {
          return (
            whats.status === "qrcode" ||
            whats.status === "PAIRING" ||
            whats.status === "DISCONNECTED" ||
            whats.status === "TIMEOUT" ||
            whats.status === "OPENING"
          );
        });
        if (offlineWhats.length > 0) {
          setConnectionWarning(true);
        } else {
          setConnectionWarning(false);
        }
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [whatsApps]);

  const fetchChats = async () => {
    try {
      const { data } = await api.get("/chats/", {
        params: { searchParam, pageNumber },
      });
      dispatch({ type: "LOAD_CHATS", payload: data.records });
    } catch (err) {
      toastError(err);
    }
  };

  const hoverTimeoutRef = useRef(null);

  const handlePopoverOpen = (name, anchorEl) => {
    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    popoverAnchors.current[name] = anchorEl;
    setOpenPopover(name);
  };

  const handlePopoverClose = (event) => {
    if (event && event.target && event.target.closest && event.target.closest("[data-nav-submenu-trigger]")) {
      return;
    }
    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    setOpenPopover(null);
  };

  const handlePopoverKeepOpen = () => {
    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
  };

  const handlePopoverToggle = (name, event) => {
    if (openPopover === name) {
      setOpenPopover(null);
    } else {
      popoverAnchors.current[name] = event.currentTarget;
      setOpenPopover(name);
    }
  };

  // Check if a simple route is active
  const isRouteActive = (path) => location.pathname === path;

  const menuIcons = {
    Whatsapp,
    Dashboard: DashboardOutlinedIcon,
    Notepad2,
    Grid1,
    HomeTrendUp,
    Flash,
    Notification1,
    MessageFavorite,
    CalendarEdit,
    UserAdd,
    Tag,
    Calendar,
    VolumeHigh,
    VolumeUp,
    Profile2User,
    Setting2,
    Kanban,
    ArrowSwapHorizontal,
    People,
    ArrowSquare,
    Hierarchy,
    Paperclip,
    MoneySend,
    Setting,
    CodeCircle,
    KeyboardOpen,
    Buliding,
    Information,
  };

  const menuItems = useMemo(() => {
    return buildMenuConfig({
      user,
      showCampaigns,
      showKanban,
      showSchedules,
      showInternalChat,
      showOpenAi,
      showIntegrations,
      showExternalApi,
      i18n,
      icons: menuIcons,
    });
  }, [
    user,
    showCampaigns,
    showKanban,
    showSchedules,
    showInternalChat,
    showOpenAi,
    showIntegrations,
    showExternalApi,
  ]);

  return (
    <div
      className={`${classes.iconRail} ${sidebarExpanded ? classes.iconRailExpanded : ""}`}
      style={{ width: sidebarWidth, minWidth: sidebarWidth }}
    >
      {/* Logo: ícone quando recolhido, logo completa quando expandido */}
      <div
        className={`${classes.logoContainer} ${sidebarExpanded ? classes.logoContainerExpanded : ""}`}
        onClick={() => history.push("/")}
      >
        <img
          src={logoIcon}
          alt="Logo"
          className={`${classes.logoImg} ${classes.logoImgCollapsed}`}
          style={{ opacity: sidebarExpanded ? 0 : 1 }}
        />
        <img
          src={logoFull}
          alt="Whattis"
          className={`${classes.logoImg} ${classes.logoImgExpanded}`}
          style={{ opacity: sidebarExpanded ? 1 : 0 }}
        />
      </div>

      <div className={sidebarExpanded ? classes.dividerExpanded : classes.divider} />

      {/* Navigation Icons */}
      <div className={`${classes.navSection} ${sidebarExpanded ? classes.navSectionExpanded : ""}`}>
        <SidebarNavFromConfig
          menuItems={menuItems}
          classes={classes}
          connectionWarning={connectionWarning}
          openPopover={openPopover}
          popoverAnchors={popoverAnchors}
          handlePopoverToggle={handlePopoverToggle}
          handlePopoverOpen={handlePopoverOpen}
          handlePopoverClose={handlePopoverClose}
          handlePopoverKeepOpen={handlePopoverKeepOpen}
          expanded={sidebarExpanded}
        />

      </div>
    </div>
  );
};

export default MainListItems;
